const getters = {
  listAll: state => {
    return state.holidayset_list
  },
  listSelected: state => {
    if (state.client_selected) {
      let holidaysets = []
      for (let index = 0; index < state.holidayset_list.length; index++) {
        const element = state.holidayset_list[index]
        if (element.Client.id === state.client_selected.id) holidaysets.push(element)
      }
      return holidaysets
    }
    return state.holidayset_list
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/holidayset/holidayset.getters.js
// module id = null
// module chunks = 